/**
 * Given an IntersectionObserver entry, returns whether the observed element is
 * out of the viewport — i.e. no part of it is currently visible, whether it is
 * still below the fold (not yet reached) or has been scrolled past above.
 *
 * Used to decide when the mobile sticky buy box bar may appear: it shows
 * whenever the buy box area is not in view, so users get the CTA both before
 * they reach the buy box on load and after they scroll past it.
 */
export const isElementOutOfView = (entry: {
  isIntersecting: boolean
}): boolean => !entry.isIntersecting
